import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

export const getComsAcsDataTableStructure = (): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.ac.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.ac.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'Autorité contractante',
    plural: 'Autorités contractantes',
    columns: [idColumn, nameColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    searchableFields: ['id', 'nom'],
  };
};
